import { type CanvasElementId } from '../canvas-element/canvas-element-id';
import { type SlotId } from '../canvas-element/slots';
import {
  BLAZE_ELEMENT_CLASS,
  BLAZE_ELEMENT_HOST_CLASS,
  BLAZE_SLOT_CLASS,
  BLAZE_TARGET_CLASS,
  ELEMENT_ID_ATTR,
  ELEMENT_PARENT_ID_ATTR,
  ELEMENT_SLOT_ATTR,
  ELEMENT_SLOT_CONTAINER_ATTR,
} from '../renderer/node-item';

/**
 * Returns HTMLElement based on the provided canvas element id
 */
// TODO: test
export function getHTMLElementForNode(
  elementId: CanvasElementId,
  slotId?: SlotId,
): HTMLElement | null {
  const selector = slotId
    ? `.${BLAZE_ELEMENT_CLASS}[${ELEMENT_ID_ATTR}="${elementId}"] [${ELEMENT_SLOT_CONTAINER_ATTR}="${slotId}"]`
    : `.${BLAZE_ELEMENT_CLASS}[${ELEMENT_ID_ATTR}="${elementId}"]`;
  return document.querySelector(selector);
}

export function getHTMLHostingElementForElement(elementId: CanvasElementId): HTMLElement | null {
  return document.querySelector(
    `.${BLAZE_TARGET_CLASS}[${ELEMENT_ID_ATTR}="${elementId}"] .${BLAZE_ELEMENT_HOST_CLASS}`,
  );
}

/** Gets slot's HTMLElement */
// TODO: test
export function getHTMLElementForColumn(
  elementId: CanvasElementId,
  slotId: SlotId,
): HTMLElement | null {
  return document.querySelector(
    `.${BLAZE_SLOT_CLASS}[${ELEMENT_ID_ATTR}="${elementId}"][${ELEMENT_SLOT_CONTAINER_ATTR}="${slotId}"]`,
  );
}

/**
 * Get collection of HTML slot's of container
 */
export function getHTMLElementsForContainerColumns(elementId: CanvasElementId): HTMLElement[] {
  return Array.from(
    document.querySelectorAll(`.${BLAZE_SLOT_CLASS}[${ELEMENT_ID_ATTR}="${elementId}"]`),
  );
}

/**
 * Get all HTML elements in a slot
 */
export function getHTMLElementsForElementsInColumn(
  containerId: CanvasElementId,
  slotId: SlotId,
): HTMLElement[] {
  return Array.from(
    document.querySelectorAll(
      `.${BLAZE_ELEMENT_CLASS}[${ELEMENT_PARENT_ID_ATTR}="${containerId}"][${ELEMENT_SLOT_ATTR}="${slotId}"]`,
    ),
  );
}
